"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSystemImage = exports.setText = exports.setTile = exports.moveToXY = exports.create = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageTileData_1 = require("./voyageTileData");
var voyageTileData_sidecar_1 = require("./voyageTileData-sidecar");
function create(i, j, x, y) {
    var image1 = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().ship1, sprites_sidecar_1.sprites.voyTileChecker1[0]);
    image1.tint = voyageColors_sidecar_1.voyageColors.g2;
    var tile1 = voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.CheckerBottom);
    var tile2 = voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.Null2);
    var tile3 = voyageTileData_sidecar_1.voyageTileData.get(voyageTileData_1.EVoyageTile.Null3);
    var obj = {
        i: i,
        j: j,
        x: x,
        y: y,
        image1: image1,
        image2: null,
        image3: null,
        // imageBreach: null,
        imageSystem: null,
        tile1: tile1,
        colorIdx1: 0,
        subTileIdx1: 0,
        tile2: tile2,
        colorIdx2: 0,
        subTileIdx2: 0,
        tile3: tile3,
        colorIdx3: 0,
        subTileIdx3: 0,
        text3: '',
        text: null,
        fire: null,
        breach: null,
        system: null,
        items: [],
        crew: [],
    };
    moveToXY(obj, x, y);
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    obj.image1.x = x;
    obj.image1.y = y;
    if (obj.image2) {
        obj.image2.x = x;
        obj.image2.y = y;
    }
    if (obj.image3) {
        obj.image3.x = x;
        obj.image3.y = y;
    }
}
exports.moveToXY = moveToXY;
function setTile(obj, 
//layer: number,
data, subTileIdx, colorIdx) {
    var img = obj.image2;
    var layer = data.layer;
    subTileIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(subTileIdx, data.frames);
    colorIdx = mathUtils_sidecar_1.mathUtils.wrapIndex(colorIdx, data.colors);
    if (layer === 1) {
        img = obj.image1;
        obj.tile1 = data;
        obj.subTileIdx1 = subTileIdx;
        obj.colorIdx1 = colorIdx;
    }
    if (layer === 2) {
        if (!obj.image2 && !data.isNull) {
            obj.image2 = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().ship2, sprites_sidecar_1.sprites.voyTileNull[0]);
            obj.image2.x = obj.x;
            obj.image2.y = obj.y;
        }
        img = obj.image2;
        obj.tile2 = data;
        obj.subTileIdx2 = subTileIdx;
        obj.colorIdx2 = colorIdx;
    }
    if (layer === 3) {
        if (!obj.image3 && !data.isNull) {
            obj.image3 = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().ship3, sprites_sidecar_1.sprites.voyTileNull[0]);
            obj.image3.x = obj.x;
            obj.image3.y = obj.y;
        }
        img = obj.image3;
        obj.tile3 = data;
        obj.subTileIdx3 = subTileIdx;
        obj.colorIdx3 = colorIdx;
    }
    if (!data.isNull) {
        assert_sidecar_1.assert.notNil(img, 'somehow image is null');
        spritesUtil_sidecar_1.spritesUtil.setPackedFrame(img, data.frames[subTileIdx]);
        //img.pi
        //spritesUtil.scale(img, 3)
        img.tint = data.colors[colorIdx];
        img.visible = true;
    }
    else {
        if (img) {
            img.visible = false;
        }
    }
}
exports.setTile = setTile;
function setText(obj, text) {
    obj.text3 = text;
    if (!obj.text && text) {
        obj.text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, voyageLayers_sidecar_1.voyageLayers.getLayers().ship3);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(obj.text, 3);
    }
    if (obj.text) {
        stevieTexts2_sidecar_1.stevieTexts2.setText(obj.text, text);
        stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.text, obj.x, obj.y);
    }
}
exports.setText = setText;
// export function setHullBreach(obj: IVoyageTilemapPart, isBreach: boolean) {
//   if (isBreach) {
//     if (!obj.imageBreach) {
//       obj.imageBreach = spritesUtil.createImage(
//         voyageLayers.getLayers().ship3,
//         sprites.voyTileChecker2[0],
//       )
//       obj.imageBreach.x = obj.x
//       obj.imageBreach.y = obj.y
//       obj.imageBreach.tint = voyageColors.damage
//     }
//   } else {
//     if (obj.imageBreach) {
//       obj.imageBreach.destroy()
//       obj.imageBreach = null
//     }
//   }
// }
function setSystemImage(t, frame, tint) {
    if (tint === void 0) { tint = 0xffffff; }
    if (!frame) {
        if (t.imageSystem) {
            t.imageSystem.destroy();
            t.imageSystem = null;
        }
    }
    else {
        if (!t.imageSystem) {
            t.imageSystem = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().ship4, frame);
            t.imageSystem.x = t.x;
            t.imageSystem.y = t.y;
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(t.imageSystem, frame);
        }
        t.imageSystem.tint = tint;
    }
}
exports.setSystemImage = setSystemImage;
